import * as fromRoot from '../../reducers';
import * as CostModuleApiReducer from './cost-module-api.reducer';
import { Action, ActionReducerMap, createFeatureSelector, createSelector } from '@ngrx/store';

export interface CostModuleState {
  status: CostModuleApiReducer.State;
}

export interface State extends fromRoot.State {
  costModule: CostModuleState;
}

export const reducers: ActionReducerMap<CostModuleState, Action> = {
  status: CostModuleApiReducer.reducer
};


export const selectCostModuleState = createFeatureSelector<State, CostModuleState>('costModule');
export const selectCostModuleStatusState = createSelector(selectCostModuleState, (state: CostModuleState) => state.status);

export const getServiceInfo = createSelector(selectCostModuleStatusState, CostModuleApiReducer.getServiceInfo);
